import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback, useMemo, useState } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { findItem } from './utils';
import { DeviceList } from './list';
import { SearchField } from 'console/shared/components/fields/search';
export const SelectingDevicesComponent = memo(function SelectingDevicesComponent(props) {
    const { devices, selected_device_ids, onChangeSelectedDeviceIds } = props;
    const selected_device_ids_set = useMemo(() => new Set(selected_device_ids), [selected_device_ids]);
    const [search, setSearch] = useState('');
    const filter_devices = useMemo(() => findItem(devices, search), [devices, search]);
    const all_selected = useMemo(() => filter_devices.every((device) => selected_device_ids_set.has(device.id)), [selected_device_ids_set, filter_devices]);
    const none_selected = useMemo(() => !filter_devices.some((device) => selected_device_ids_set.has(device.id)), [selected_device_ids_set, filter_devices]);
    const handleToggle = useCallback((value) => () => {
        const new_set = new Set(selected_device_ids_set);
        if (selected_device_ids_set.has(value))
            new_set.delete(value);
        else
            new_set.add(value);
        onChangeSelectedDeviceIds(Array.from(new_set));
    }, [selected_device_ids, onChangeSelectedDeviceIds]);
    const onClickSelectAll = useCallback(() => {
        if (all_selected) {
            onChangeSelectedDeviceIds([]);
        }
        else {
            onChangeSelectedDeviceIds(filter_devices.map((dev) => dev.id));
        }
    }, [all_selected, onChangeSelectedDeviceIds, filter_devices]);
    const onChangeSearch = useCallback((value) => {
        setSearch(value);
    }, [setSearch]);
    const onClearSearch = useCallback(() => {
        setSearch('');
    }, [setSearch]);
    const devices_len = filter_devices.length;
    return (_jsx(ErrorBoundary, { children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(SearchField, { value: search, onChange: onChangeSearch, onClear: onClearSearch }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(FormControlLabel, { sx: { ml: 0 }, control: _jsx(Checkbox, { checked: all_selected, onChange: onClickSelectAll, indeterminate: !none_selected && !all_selected }), label: all_selected ? 'Снять выбор' : 'Выбрать всё' }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(DeviceList, { selected_device_ids: selected_device_ids, devices: filter_devices, devices_len: devices_len, handleToggle: handleToggle, is_autoscan: true }) })] }) }));
});
